import type { Novidade } from './tipos';

/** Fase 2 (W33): seletor de período em abas, subtítulo em cada página e o cartão do Resend com o envio pela plataforma. */
export const novidadePaginas: Novidade = {
  id: '2026-10-05-paginas',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: null,
  permissao: null,
  textos: {
    pt: {
      titulo: 'Período em abas e uma descrição em cada página',
      resumo: 'O seletor de período ganhou as abas Atalhos, Mês específico e Período, e cada página mostra uma frase curta sobre o que ela faz.',
      passos: [
        'No Início e nos Relatórios, clique no período (por exemplo, Outubro / 2026) e escolha um atalho, um mês ou as datas De e Até.',
        'Logo abaixo do título de cada página há uma descrição curta da tela, nos três idiomas.',
        'Em Integrações, Conectores, o cartão do Resend mostra quando os e-mails já saem pela plataforma. Configure o seu para usar o domínio da empresa.',
      ],
    },
    en: {
      titulo: 'Period in tabs and a description on every page',
      resumo: 'The period picker now has the Shortcuts, Specific month and Range tabs, and every page shows a short sentence about what it does.',
      passos: [
        'On Home and in Reports, click the period (for example, October / 2026) and choose a shortcut, a month or the From and To dates.',
        'Right below the title of every page there is a short description of the screen, in the three languages.',
        "In Integrations, Connectors, the Resend card shows when e-mails already go out through the platform. Set up your own to use the company's domain.",
      ],
    },
    es: {
      titulo: 'Período en pestañas y una descripción en cada página',
      resumo: 'El selector de período ahora tiene las pestañas Atajos, Mes específico y Período, y cada página muestra una frase corta sobre lo que hace.',
      passos: [
        'En Inicio y en Informes, haz clic en el período (por ejemplo, Octubre / 2026) y elige un atajo, un mes o las fechas Desde y Hasta.',
        'Justo debajo del título de cada página hay una descripción corta de la pantalla, en los tres idiomas.',
        'En Integraciones, Conectores, la tarjeta de Resend muestra cuándo los correos ya salen por la plataforma. Configura el tuyo para usar el dominio de la empresa.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-paginas/periodo.webp', '/novidades/2026-10-05-paginas/subtitulo.webp', '/novidades/2026-10-05-paginas/resend.webp'],
  treinamento: { curso: 'novidades' },
  rota: '/',
};
